import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfileDto } from "../../interfaces";
import { logout } from "./authSlice";

export interface AccountState {
  userProfile: UserProfileDto | null;
}

const initialState: AccountState = {
  userProfile: null,
};
const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<UserProfileDto | null>) {
      state.userProfile = action.payload;
    },
    setProfileImage(state, action: PayloadAction<string>) {
      if (state.userProfile) {
        state.userProfile.profilePhoto = action.payload;
      }
    },
    clearAccount() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setProfile, setProfileImage, clearAccount } =
  accountSlice.actions;
export default accountSlice.reducer;
